import axios from './authService';
import { API_ENDPOINTS } from '../config/apiConfig';

const unwrap = (r) => r.data;

export async function searchLocators({
  name_or_value = '',
  platform,
  build,
  page,
  market_id,
  limit,
  offset,
  sort_by,
  sort_order,
} = {}) {
  const params = new URLSearchParams({ name_or_value });
  if (platform) params.set('platform', platform);
  if (market_id != null) params.set('market_id', String(market_id));
  if (limit != null) params.set('limit', String(limit));
  if (offset != null) params.set('offset', String(offset));
  if (build != null && build !== '') params.set('build', String(build));
  if (page) params.set('page', page);
  if (sort_by) params.set('sort_by', sort_by);
  if (sort_order) params.set('sort_order', sort_order);
  const response = await axios.get(`${API_ENDPOINTS.LOCATORS_SEARCH}?${params}`);
  return unwrap(response);
}

export async function createLocator(payload) {
  const response = await axios.post(API_ENDPOINTS.LOCATORS_CREATE, payload);
  return unwrap(response);
}

export async function listLocatorPages() {
  const response = await axios.get(API_ENDPOINTS.LOCATORS_PAGES);
  return unwrap(response).pages;
}

export async function updateLocator(id, { locator_type, locator_value }) {
  const response = await axios.put(API_ENDPOINTS.LOCATORS_UPDATE(id), {
    locator_type,
    locator_value,
  });
  return unwrap(response);
}
